<template>
	<div class="ReClientMultiOpFilter">

		<card class="majorFilter-card filter">
			<base-button @click="HideFilter()" class="btn-close no-border my-0" type="primary" simple icon><i class="tim-icons icon-simple-remove"></i></base-button>
			<div class="filter-options">
				<div class="filter-options-group px-0 col-md-12">
					<div class="row" >
						<label class="col-form-label col-md-3">По клиенту</label>
						<div class="form-group col-md-9">
							<ReSearchStaffClients 
								placeholder="ФИО сотрудника"
								placeholder_otdel="Название отдела"
								v-model="objFilterData.structure.value"
								:objApiMethod="{'obj':'staff','flt':{'fio':''}}"
								:strApiMethodKey="'fio'"
								:objApiMethod_otdel="{'obj':'structures','flt':{'name':''}}"
								:strApiMethodKey_otdel="'name'"
								:rb_options="objFilterData.structure.rb_options"
								v-on:change="OnAjaxListSearch"
							/>
						</div>
					</div>
					<div class="row">
						<label class="col-form-label col-md-3">По наличию услуг</label>
						<div class="col-md-9 checkbox-radios">
							<base-radio v-for="(el_opt, el_index) in objFilterData.rb_service.options" 
							:name="el_opt.value" 
							:label="el_opt.label" 
							:key="el_index"
							v-model="objFilterData.rb_service.value" 
							inline>{{el_opt.label}}</base-radio>
						</div>
					</div>

					<div class="row" v-if="this.objFilterData.rb_service.value != 2 ">
						<label class="col-form-label col-md-3">Включить статусы услуги</label>
						
						<div class="col-md-9 checkbox-radios">
							<base-checkbox v-model="objFilterData.srv_oncontrol.value" inline :disabled="objFilterData.srv_oncontrol_excl.value"
							>На контроле</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_new.value" inline :disabled="objFilterData.srv_new_excl.value">Новые</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_inwork.value" inline :disabled="objFilterData.srv_inwork_excl.value">В работе</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_sdelka.value" inline :disabled="objFilterData.srv_sdelka_excl.value">Сделка</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_arhiv.value" inline :disabled="objFilterData.srv_arhiv_excl.value">Архив</base-checkbox>
						</div>
						<label class="col-form-label col-md-3">Исключить статусы услуги</label>
						<div class="col-md-9 checkbox-radios">
							<base-checkbox v-model="objFilterData.srv_oncontrol_excl.value" inline :disabled="objFilterData.srv_oncontrol.value"
							>На контроле</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_new_excl.value" inline :disabled="objFilterData.srv_new.value">Новые</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_inwork_excl.value" inline :disabled="objFilterData.srv_inwork.value">В работе</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_sdelka_excl.value" inline :disabled="objFilterData.srv_sdelka.value">Сделка</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_arhiv_excl.value" inline :disabled="objFilterData.srv_arhiv.value">Архив</base-checkbox>
						</div>
					</div>
					<div class="row" v-if="this.objFilterData.rb_service.value != 2">
						<label class="col-form-label col-md-3">По конкретной услуге</label>
						<div class="col-md-9 d-flex">
							<el-select
									class="w-100 px-0 select-primary mb-3"
									v-model="objFilterData.bp_id.value" 
									placeholder="Выбрать услугу"
									size="large"
									clearable
									filterable
								>
								<el-option
									class="select-primary"
									v-for="(el_opt, el_index) in selServOpts"
									:value="el_opt.value"
									:label="el_opt.label"
									:key="el_index" 
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.bp_id.value= '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>

						</div>
					</div>
					<div class="row" v-if="this.objFilterData.rb_service.value != 2">
						<label class="col-form-label col-md-3">По источнику лида</label>
						<div class="col-md-9 d-flex">
							<el-select
									class="w-100 px-0 select-primary mb-3"
									v-model="objFilterData.adsSourceName.value" 
									placeholder="Выбрать источник"
									size="large"
									clearable
									filterable
								>
								<el-option
									class="select-primary"
									v-for="(el_opt, el_index) in objAdsData"
									:value="el_opt.value"
									:label="el_opt.label"
									:key="el_index" 
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.adsSourceName.value= '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>

						</div>
					</div>

					<div class="row">
						<label class="col-form-label col-md-3">Время добавления клиента</label>
						<div class="form-group col-md-9">
							<ReStrangeDateRange 
								placeholder="Время добавления клиента"
								v-model="objFilterData.byTimeRange.value"
							/>
						</div>
					</div>

					<div class="row">
						<label class="col-form-label col-md-3">Исключить клиентов агента</label>
						<div class="form-group col-md-9 d-flex">
							<ReInputSearchDrop 
								class="w-100"
								:name="objFilterData.excludeAgent.name"
								:placeholder="objFilterData.excludeAgent.placeholder"
								v-model="objFilterData.excludeAgent.value"
								:objApiMethod="objFilterData.excludeAgent.objApiMethod"
								:strApiMethodKey="objFilterData.excludeAgent.strApiMethodKey"
								:strType="objFilterData.excludeAgent.strType"
								v-on:change="OnAjaxListSearch"
							/>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.excludeAgent.value = {'inputText':'','selectedVal':''};"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
						</div>
					</div>

				</div>
				<div class="applyFilter bntGroup">
					<base-button @click="OnFilterApply()" type="success" class="mr-2 btn-simple">Применить</base-button>
					<!-- <base-button @click="OnFilterReset();" type="danger" class="mr-2 btn-simple">Сбросить</base-button> -->
				</div>
				<!-- <div class="firstFilter-row filter-tags mt-2">
					<el-tag
						v-for="tag in filterTags"
						:key="tag.param_id"
						size="small"
						:closable="true"
						:close-transition="false"
						@close="handleClose(tag)"
						:type="'primary'"
					>
					{{ tag.name }}
					</el-tag>
					<span v-if="optCount != ''" class="el-tag el-tag--danger el-tag--small el-tag--light"> Сбросить всё <i class="el-tag__close el-icon-close" @click="OnFilterReset()"></i></span>
				</div> -->

			</div>
		</card>



	</div>
</template>
<script>

// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import { Select, Option, Checkbox, Tag } from 'element-ui';
import { BaseCheckbox, BaseRadio } from 'src/components/index';
import ReSearchStaffClients from 'src/our_components/ReSearchStaffClients.vue';
import ReStrangeDateRange from 'src/our_components/ReStrangeDateRange.vue';
import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
import {eventEmitter} from "src/plugins/globalComponents";

export default {
	name: 'ReClientMultiOpFilter',
	components: {
		// ReFilter,
		// ReFilterBtn,
		[Tag.name]: Tag,
		[Option.name]: Option,
		[Select.name]: Select,
		[Checkbox.name]: Checkbox, 
		ReSearchStaffClients,
		BaseCheckbox,
		BaseRadio,
		ReStrangeDateRange,
		ReInputSearchDrop,
	},
	props: {
		value: String,
		
	},
	data() {
		return {
			bShowFilter: false,
			BigSearch: {inputText: '', selectedVal:''}, //поиск по городу и прочему. Вопрос про формат данных и их соответсвие с базой
			objApiData:{},
			objAdsData:{},
			objGetParams: {},
			masExcludeParams: ['page','p','c2p','client_id','taskend_id','task_id','service_id'],
			selServOpts: [],
			// leadsSourceNameOpts: [],
			optCount: '',
			filterTags:[],
			objFilterData: { //Правила: 1) Имя свойсва - это параметр отправляем в GET метод АПИ; 2) одно свойство - одно поле/компонет. 3) В свойстве поле value привязывать к v-model поля/компонета. 4) Все поля/компонета должны уметь v-model
				excludeAgent:{
					value:{'inputText':'','selectedVal':''},
					name:'',
					elementType: 'ajax-list',
					objApiMethod:{'obj':'staff','flt':{'fio':''}},
					strApiMethodKey:'fio',
				},
				structure: {
					value: {'agent_id':'','otdel_id':'','isFired':''}, 
					tagText:'Клиенты', 
					elementType: 'ajax-list-client', 
					rb_options: [{'name': '0', 'label': 'Все клиенты'},{'name': '1', 'label': 'Мои клиенты'}], 
					value_default: {'agent_id':'','otdel_id':'','isFired':''},
					catalog:'CAT_STAFF',
				}, //'elementGetParamMap'=>'agent_id|otdel_id|isFired',
				rb_service: {value:'1', elementType: 'servicesRadio', value_default: '', options:[
					{value: 1, label: 'С услугой'}, 
					{value: 2, label: 'Без услуги'},
				], tagText:'Услуги'},
				//rb_service

				srv_oncontrol:{value:false, tagText:'На контроле', elementType: 'checkbox', value_default: false},
				srv_new:{value:false, tagText:'Новые', elementType: 'checkbox', value_default: false},
				srv_inwork:{value:false, tagText:'В работе', elementType: 'checkbox', value_default: false},
				srv_sdelka:{value:false, tagText:'Сделка', elementType: 'checkbox', value_default: false},
				srv_arhiv:{value:false, tagText:'Архив', elementType: 'checkbox', value_default: false},

				srv_oncontrol_excl:{value:false, tagText:'На контроле', elementType: 'checkbox', value_default: false},
				srv_new_excl:{value:false, tagText:'Новые', elementType: 'checkbox', value_default: false},
				srv_inwork_excl:{value:false, tagText:'В работе', elementType: 'checkbox', value_default: false},
				srv_sdelka_excl:{value:false, tagText:'Сделка', elementType: 'checkbox', value_default: false},
				srv_arhiv_excl:{value:false, tagText:'Архив', elementType: 'checkbox', value_default: false},

				bp_id: {value:'', catalog:'', options:[], tagText:'Услуга', elementType: 'select', value_default: ''},
				adsSourceName: {value:'', catalog:'', options:[], tagText:'Источник', elementType: 'select', value_default: ''},
				byTimeRange: {
					value: {'cl_range_type':'5','cl_range_date':{'endDt':'', 'startDt':''}},
					tagText:'Время',
					elementType: 'date-range-strange', 
				},
			}
		};
	},
	computed: {
		// bInObjectPage(){
		// 	if(location.pathname.indexOf('/data/clients/id/') != -1) return true;
		// 	return false;
		// },
		
	},
	created(){
		// if(typeof this.$GVO.my_profile != 'undefined' && typeof this.$GVO.my_profile.is_boss != 'undefined'){
		// 	if(this.$GVO.my_profile.is_boss!==0){
		// 		if(this.objFilterData.structure.rb_options.length==2){
		// 			this.objFilterData.structure.rb_options.push({'name': '2', 'label': 'Клиенты сотрудника'});
		// 			this.objFilterData.structure.rb_options.push({'name': '3', 'label': 'Клиенты отдела'});
		// 			this.objFilterData.structure.rb_options.push({'name': '4', 'label': 'Клиенты уволенных'});
		// 		}
		// 	}
		// }

	},
	methods: {
		findTag(tag){
			for (let i = 0; i < this.filterTags.length; i++) {
				const elTag = this.filterTags[i];
				if(/*elTag.name == tag.name && */elTag.param_id == tag.param_id) return i;
			}
			return -1;
		},
		translateTags(data){
			let strValue = '';
			let masValue = [];
			if(data.selectedType == 'ajax-list-client'){
				data.selectedType = 'structure';
				if(this.objFilterData[data.selectedType].value.agent_id != ''){
					masValue.push(this.objFilterData[data.selectedType].value.agent_id);
				}
				if(this.objFilterData[data.selectedType].value.otdel_id != ''){
					masValue.push(this.objFilterData[data.selectedType].value.otdel_id);
				}
				if(this.objFilterData[data.selectedType].value.isFired != ''){
					masValue.push(this.objFilterData[data.selectedType].value.isFired);
				}
			}else{
				strValue = this.objFilterData[data.selectedType].value;
				masValue = strValue.split(';');
			}
			for (let i = 0; i < masValue.length; i++) {
				masValue[i] = this.$GVO.GetCat(this.objFilterData[data.selectedType].catalog,masValue[i]).name;
				//для this.objFilterData['structure'] придумать что-то с каталогом для имён сотрудников и отделов
			}
			strValue = masValue.join(';');
			return strValue;
		},
		OnBigSearch(data){
			let masTmp = [];
			if(typeof this.objFilterData[data.selectedType] != 'undefined'){
				let strValue = this.translateTags(data);

				let tag = {name: `${this.objFilterData[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
				if(this.findTag(tag) != -1) this.filterTags.splice(this.findTag(tag), 1); // закрываем старый тег

				if(this.objFilterData[data.selectedType].value != ''){
					masTmp = this.objFilterData[data.selectedType].value.split(';');
				}
				masTmp.push(data.selectedVal);
				this.objFilterData[data.selectedType].value = masTmp.join(';');

				this.BigSearch.inputText='';
				strValue = this.translateTags(data);

				tag = {name: `${this.objFilterData[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
				this.filterTags.push(tag);
			}
		},
		handleClose(tag,bApply=true) { // переделать всё на this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default)
			if(this.objFilterData[tag.param_id].elementType == 'input-range'){
				this.objFilterData[tag.param_id].value.min = '';
				this.objFilterData[tag.param_id].value.max = '';
			} else if(this.objFilterData[tag.param_id].elementType == 'checkbox'){
				this.objFilterData[tag.param_id].value = false;
			} else if(this.objFilterData[tag.param_id].elementType == 'ajax-list-client'){
				this.objFilterData[tag.param_id].value = this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default);
			} else {
				this.objFilterData[tag.param_id].value = '';
			}
			this.filterTags.splice(this.findTag(tag), 1);
			if(bApply) this.OnFilterApply();
		},
		setOptCount(data=false){ // тут не только считается количество параметров в фильтре. НО и отрисовка тегов
			if(!data){
				this.objGetParams = this.$GVO.GetAllGet();
			}else{
				this.objGetParams = data;
			}
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				let masKeys = Object.keys(this.objGetParams);
				let iOptsCount = 0;
				this.filterTags = [];
				if(typeof this.masExcl != 'undefined'){
					this.masExcludeParams = [...this.masExcludeParams, ...this.masExcl];
				}
				for (let i = 0; i < masKeys.length; i++) {
					if(this.masExcludeParams.indexOf(masKeys[i]) === -1){									
						if(this.objGetParams[masKeys[i]] !== false && this.objGetParams[masKeys[i]] !== 'false'){
							//console.log('setOptCount_masKeys_i',masKeys[i]);
							let element = this.getFilterDataElement(masKeys[i]);
							if(typeof element === 'undefined') continue;
							//console.log('setOptCount_element',element);
							let bInTags = false;
							for (let iTag = 0; iTag < this.filterTags.length; iTag++) {
								if(this.filterTags[iTag].param_id == element.param_id){
									bInTags = true;
								}
							}
							if(!bInTags){
								iOptsCount++;
								let tag = {name: `${element.tagText}: ${element.value}`, param_id: element.param_id};
								if(element.elementType == 'input-range'){
									let strText = '';
									if(!this.$GVO.isEmpty(element.value.min)){
										strText += 'от '+element.value.min;
									}
									if(!this.$GVO.isEmpty(element.value.max)){
										strText += ' до '+element.value.max;
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} else if(element.elementType == 'checkbox'){
									if(element.value == true){
										tag = {name: element.tagText, param_id: element.param_id};
									}else{
										tag = null;
									}
								}else if(element.elementType == 'select'){
									let strText = '';
									for (let iSel = 0; iSel < element.options.length; iSel++) {
										//if(element.options[iSel].value == element.value) strText = element.options[iSel].label;
										if(element.value.indexOf(element.options[iSel].value) != -1) strText += element.options[iSel].label+';';
									}
									tag = {name: `${element.tagText}: ${strText.slice(0, -1)}`, param_id: element.param_id};
								} else if(element.elementType == 'ajax-list-client'){
									let strText = '';
									if(element.value.agent_id != ''){
										strText = 'агент ';
										strText += this.translateTags({selectedType: element.elementType});
									}
									if(element.value.otdel_id != ''){
										strText = 'отдел';
									}
									if(element.value.isFired != ''){
										strText += ' с уволенными';
									}
									tag = {name: `${element.tagText}: ${strText} ${element.value.otdel_id}`, param_id: element.param_id};
								} else if(element.elementType == 'servicesRadio'){
									let strText = '';
									for (let iserv = 0; iserv < this.objFilterData.rb_service.options.length; iserv++) {
										if(this.objFilterData.rb_service.options[iserv].value == element.value) {
											strText = this.objFilterData.rb_service.options[iserv].label;
										}
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								}
								if(tag != null ) this.filterTags.push(tag);
							}						
						}
					}
				}
				this.optCount = iOptsCount;
			} else {
				this.optCount = '';
				this.filterTags = [];
			}
		},
		getFilterDataElement(strKey){
			if (this.objFilterData.hasOwnProperty(strKey)){
				this.objFilterData[strKey].param_id = strKey;
				return this.objFilterData[strKey];
			} else if(strKey == 'agent_id' || strKey == 'otdel_id' || strKey == 'isFired'){
				this.objFilterData['structure'].param_id = 'structure';
				return this.objFilterData['structure'];
			// } else if(strKey == 'cl_range_type' || strKey == 'cl_range_date'){
				// this.objFilterData['structure'].param_id = 'structure';
				// return this.objFilterData['byTimeRange'];
			}
			// else if(strKey == 'dWayTypeFromMetro' || strKey == 'dTimeFromMetro'){
			// 	this.objFilterData['distanceToMetro'].param_id = 'distanceToMetro';
			// 	return this.objFilterData['distanceToMetro'];
			// } 
		},

		ShowFilter(){
			this.bShowFilter = !this.bShowFilter;
		},
		SetFilterParams(){ // загружает значения в фильтр из ГЕТ строки
			//console.log('SetFilterParams',this.$GVO.unlinkObject(this.objGetParams));
			for (const key in this.objGetParams) {
				if (this.objGetParams.hasOwnProperty(key)) {
					// let element = this.getFilterDataElement(key);
					//console.log(key,element);

					if (this.objFilterData.hasOwnProperty(key)) {
						if(this.objGetParams[key] != '' && this.objGetParams[key] != '[object Object]'){
							//this.objFilterData[key].value = this.objGetParams[key];
							if (typeof this.objFilterData[key].value == 'boolean') {
								this.objFilterData[key].value = parseInt(this.objGetParams[key])==0?false:true;
							} else {
								this.objFilterData[key].value = this.objGetParams[key];
							}
						}
					}

					if(key == 'agent_id' || key == 'otdel_id' || key == 'isFired'){
						//console.log('structure '+key);
						this.objFilterData['structure'].value[key] = this.objGetParams[key];
					}
					if(key == 'cl_range_type'){
						if(this.objGetParams['cl_range_date']){
							let date = String(this.objGetParams['cl_range_date']).split(';')
							this.objFilterData['byTimeRange'].value={
								cl_range_type: this.objGetParams[key],
								cl_range_date: {startDt: date[0], endDt: date[1]}
							};
						}else{
							this.objFilterData['byTimeRange'].value[key] = this.objGetParams[key];
						}

					}
					if(key == 'inputText' || key == 'selectedVal'){

					}
					// if(key == 'cl_range_date'){
						// debugger;
						
						// this.objFilterData['byTimeRange'].value[key].startDt = date[0];
						//  this.objFilterData['byTimeRange'].value[key].endDt=date[1];
					// }
					// if(key == 'srv_new'){
					// 	//console.log('structure '+key);
					// 	this.objFilterData['srv_new'].value[key] = this.objGetParams[key];
					// }
				}
			}
			this.OnFilterApply();
		},
		

		ApplyFilterParams(){ // подготавливает значения из фильтра для ГЕТ строки
			//console.log('ApplyFilterParams',this.objFilterData );
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key)) {
					let element = this.getFilterDataElement(key);
					if(element.elementType == 'checkbox'){
						if(element.value === true){
							// this.objGetParams[key] = this.objFilterData[key].value===true?1:0;
							this.objGetParams[key] = this.objFilterData[key].value;
						}else{
							delete this.objGetParams[key];
						}
					}else if(element.elementType == 'ajax-list-client'){ // if(key == 'agent_id' ||key == 'otdel_id' ||key == 'isFired'){
						if(typeof this.objFilterData.structure.value.agent_id != 'undefined' && this.objFilterData.structure.value.agent_id != ''){
							this.objGetParams['agent_id'] = this.objFilterData.structure.value.agent_id;
						} else {
							delete this.objGetParams['agent_id'];
						}
						if(typeof this.objFilterData.structure.value.otdel_id != 'undefined' && this.objFilterData.structure.value.otdel_id != ''){
							this.objGetParams['otdel_id'] = this.objFilterData.structure.value.otdel_id;
						} else {
							delete this.objGetParams['otdel_id'];
						}
						if(typeof this.objFilterData.structure.value.isFired != 'undefined' && this.objFilterData.structure.value.isFired != ''){
							this.objGetParams['isFired'] = this.objFilterData.structure.value.isFired;
						} else {
							delete this.objGetParams['isFired'];
						}
					}else if(element.elementType == 'ajax-list'){
						if(typeof this.objFilterData.excludeAgent.value.inputText != 'undefined' && this.objFilterData.excludeAgent.value.inputText != ''){
							//this.objGetParams['inputText'] = this.objFilterData.excludeAgent.value.inputText;
						} else {
							delete this.objGetParams['inputText'];
						}
						if(typeof this.objFilterData.excludeAgent.value.selectedVal != 'undefined' && this.objFilterData.excludeAgent.value.selectedVal != ''){
							this.objGetParams['excludeAgent'] = this.objFilterData.excludeAgent.value.selectedVal;
						} else {
							delete this.objGetParams['selectedVal'];
							delete this.objGetParams['excludeAgent'];
						}
					}else if(element.elementType == 'date-range-strange'){ // value: {'cl_range_type':'5','range_date':{'endDt':'', 'startDt':''}},
						if(typeof this.objFilterData.byTimeRange.value.cl_range_type != 'undefined' && this.objFilterData.byTimeRange.value.cl_range_type != ''){
							this.objGetParams['cl_range_type'] = this.objFilterData.byTimeRange.value.cl_range_type;
						} else {
							delete this.objGetParams['cl_range_type'];
						}
						if(typeof this.objFilterData.byTimeRange.value.cl_range_date.startDt != 'undefined' && this.objFilterData.byTimeRange.value.cl_range_date.startDt != ''){
							this.objGetParams['cl_range_date'] = this.objFilterData.byTimeRange.value.cl_range_date.startDt + ';' + this.objFilterData.byTimeRange.value.cl_range_date.endDt;
						} else {
							delete this.objGetParams['cl_range_date'];
						}
					}else{
						if(!this.$GVO.isEmpty(this.objFilterData[key].value) || this.objFilterData[key].value == '[object Object]'){
							this.objGetParams[key] = this.objFilterData[key].value;
						}else{
							delete this.objGetParams[key];
						}
					}
				}
			}
			this.bShowFilter = false;
		},

		
		OnFilterApply(){ // применяет параметры из фильтра и запускает запрос к АПИ
			//console.log('OnFilterApply in filter',this.$GVO.GetAllGet());
			/**/
			// if(typeof this.$GVO.GetAllGet().dSearchType !='undefined' && this.objFilterData.dSearchType.value != this.$GVO.GetAllGet().dSearchType) {
			// 	this.objFilterData.dSearchType.value = this.$GVO.GetAllGet().dSearchType;
			// }
			
			//console.log('OnFilterApply in filter',this.objGetParams);
			// debugger;
			this.ApplyFilterParams();
			this.setOptCount(this.objGetParams);
			//console.log(this.objGetParams);

			if(location.search.substr(1) != this.$GVO.ObjToQueryString(this.objGetParams).substr(1)){
				this.$emit('change',this.$GVO.ObjToQueryString(this.objGetParams).substr(1));
			}
		},
		OnFilterReset(){
			// console.log('OnFilterReset in filter');
			// this.objFilterData.srv_new = 0;
			// this.objFilterData.srv_inwork = 0;
			// this.objGetParams.srv_new = this.objFilterData.srv_new.value;

			// srv_new:{value:true, tagText:'Новые', elementType: 'checkbox', value_default: true},
			// srv_inwork:{value:true, tagText:'В работе', elementType: 'checkbox', value_default: true},

			this.objGetParams = {};
			// this.objFilterData.byTimeRange.value.cl_range_type = '5';
			
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key) && this.masExcludeParams.indexOf(key) == -1) {
					this.objFilterData[key].value = this.$GVO.SafeParseJson(JSON.stringify(this.objFilterData[key].value_default));
				}
			}
			this.OnFilterApply();
		},

		OnAjaxListSearch(opt){

		},
		// SetCats(strCat){
		// 	for (const key in this.objFilterData) {
		// 		if (this.objFilterData.hasOwnProperty(key)) {
		// 			if(typeof this.objFilterData[key].catalog != 'undefined' && this.objFilterData[key].catalog == strCat){
		// 				this.objFilterData[key].options = this.$GVO.getCatToSelect(this.objFilterData[key].catalog);
		// 			}
		// 		}
		// 	}
		// },
		getBPList(){
			this.$GVO.ApiCall('GET',{obj:'BP',flt:{'list':true,'only_act':1/*,'archived':true,'only_act':true*/}})
			.then((objApi) => {
				if(objApi.success === true){
					this.selServOpts = [];
					//console.log(objApi);
					this.objApiData=objApi.data.BP_DATA;
					for (let i = 0; i < objApi.data.BP_DATA.length; i++) {
						this.selServOpts.push({'value':objApi.data.BP_DATA[i].id.toString(),'label':objApi.data.BP_DATA[i].name});
					}
					if(typeof this.objGetParams['bp_id'] !='undefined' && this.objGetParams['bp_id'] != '') this.value.bp_id = this.objGetParams['bp_id'];

				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		getAdsSourceName(){
			// это для фильтра, который назвается в лейбле "По источнику лида", хотя тут на самом деле источники рекламы -- так было задумано Артемом и Таней
			this.$GVO.ApiCall('GetCatForSelOptions',{obj:'../plugins/leads2bpservice',flt:{/*'list':true,,'archived':true,'only_act':true*/}})
			.then((objApi) => {
				if(objApi.success === true){
					this.adsSourceNameOpts =[];
					
					this.objAdsData=objApi.data;
					for (let i = 0; i < objApi.data.BP_DATA.length; i++) {
						this.leadsSourceNameOpts.push({'value':objApi.data.BP_DATA[i].id.toString(),'label':objApi.data.BP_DATA[i].name});
					}
					if(typeof this.objGetParams['bp_id'] !='undefined' && this.objGetParams['bp_id'] != '') this.value.bp_id = this.objGetParams['bp_id'];
					// console.log('objAdsData ', this.objAdsData);
				}
			}).catch(errorObjApi => console.error(errorObjApi));

			
		},
		HideFilter(){
			eventEmitter.$emit('HideFilter', true);
		},
	},
	async mounted() {
		this.getBPList();
		this.getAdsSourceName();
		await this.$GVO.profile_load;
		if(typeof this.$GVO.my_profile != 'undefined' && typeof this.$GVO.my_profile.is_boss != 'undefined'){
				if(this.$GVO.my_profile.is_boss!==0){
					if(this.objFilterData.structure.rb_options.length==2){
						this.objFilterData.structure.rb_options.push({'name': '2', 'label': 'Клиенты сотрудника'});
						this.objFilterData.structure.rb_options.push({'name': '3', 'label': 'Клиенты отдела'});
						// this.objFilterData.structure.rb_options.push({'name': '4', 'label': 'Клиенты уволенных'}); //12.04.24 Артем: если увольняется сотрудник, все его услуги перемешиваются на руководителя автоматом	
					}
				}
			}
			this.objGetParams = this.$GVO.GetAllGet();
			this.SetFilterParams();
		
		
		this.SetFilterParams();
		this.objGetParams = this.$GVO.GetAllGet();
		
		// eventEmitter.$on('profile_load', this.update_rb_options)
			
	},
	// beforeDestroy() {
		// Отписываемся от события
		// eventEmitter.$off('profile_load', this.update_rb_options);
	// },
};
</script>
<style scoped>
/* .majorFilter-card {border: 1px solid #01b0e0;}
.majorFilter {display: flex; justify-content: space-between;} */

.ReClientMultiOpFilter .bntGroup{
	display: flex;
	justify-content: flex-end;		
}
.ReClientMultiOpFilter .btn-close{
	position: absolute;
	right:10px;
	top:0px;
}

</style>
